import {
	createMenuStore,
	useMenu,
} from '@netx/core-app-next/store/menuItemsBase';
import {assetExpirationActionListRoute} from '@netx/core-asset-expiration/actions/asset-expiration-list-route';
import {dataSetActionDataSetsManageRoute} from '@netx/core-data-set/actions/data-sets-manage-route';
import {downloadRequestActionRequestsManageRoute} from '@netx/core-download-request/actions/download-requests-manage-route';
import {projectReviewActionReviewsRoute} from '@netx/core-project-review/actions/project-reviews-route';
import {shareLinkActionLinksRoute} from '@netx/core-share-link/actions/share-links-route';
import {statsActionStatsRoute} from '@netx/core-stat-next/actions/stats-route';
import {uploadAssetRequestActionRequestsManageRoute} from '@netx/core-upload-asset-request-manager/actions/upload-asset-requests-manage-route';
import {attributeUploadActionRoute} from '@netx/core-attribute-upload/actions/attributes-upload-route';
import {uploadCartCurrentUploadAction} from '@netx/core-cart-current-upload/actions/cart-current-upload-route';
import {systemPeopleActionRoute} from '@netx/core-system-people/actions/system-people-route';

export const useAppToolsItemsStore = createMenuStore();

export const useAppToolsMenu = () => useMenu({store: useAppToolsItemsStore});

export enum AppToolsMenuSection {
	TOOLS = 'tools',
}

useAppToolsItemsStore
	.getState()
	.addMenuItems(
		[
			downloadRequestActionRequestsManageRoute(),
			uploadAssetRequestActionRequestsManageRoute(),
			attributeUploadActionRoute(),
			dataSetActionDataSetsManageRoute(),
			assetExpirationActionListRoute(),
			shareLinkActionLinksRoute(),
			projectReviewActionReviewsRoute(),
			uploadCartCurrentUploadAction(),
			statsActionStatsRoute(),
			systemPeopleActionRoute(),
		],
		{section: AppToolsMenuSection.TOOLS},
	);
